import React, { FC } from 'react'
import ParcelSearchInput from './ParcelSearchInput'
import { useAppSelector } from '../../hooks'
import { selectResults } from '../searchSlice'
import ParcelSearchResults from './ParcelSearchResults'



const ParcelSearch: FC = () => {
  const results = useAppSelector(selectResults)

  return (
    <>
      <ParcelSearchInput />
      {results !== null ? (
        <h4>{results.length} Results</h4>
      ) : (
        <span></span>
      )}
      <div className="container-scroll" id="search-results-container">
        <ParcelSearchResults />
      </div>
    </>
  )
}


export default ParcelSearch